export const MAX_ROWS_EXPORT = 1048576

export const OPERATION_RECEIPT = 'receipt'
export const OPERATION_MOVE = 'move'
export const OPERATION_SALE = 'sale'
export const OPERATION_DISPOSAL = 'disposal'

export const EQUIPMENT_CREATED = 'created'
export const EQUIPMENT_RECEIPTED = 'receipted'
export const EQUIPMENT_MOVED = 'moved'
export const EQUIPMENT_SOLD = 'sold'
export const EQUIPMENT_DISPOSED = 'disposed'

export const INVENTORY_PENDING = 'pending'
export const INVENTORY_ACCEPTED = 'accepted'
export const INVENTORY_REJECTED = 'rejected'

export const OPERATIONS = {
  [OPERATION_RECEIPT]: {
    caption: 'Поступление',
  },
  [OPERATION_MOVE]: {
    caption: 'Перемещение',
  },
  [OPERATION_SALE]: {
    caption: 'Продажа',
  },
  [OPERATION_DISPOSAL]: {
    caption: 'Ликвидация',
  },
}

export const EQUIPMENT_WORK_FLOW = {
  [EQUIPMENT_CREATED]: {
    caption: 'Создан',
    actions: [OPERATION_RECEIPT, OPERATION_MOVE, OPERATION_SALE, OPERATION_DISPOSAL],
  },
  [EQUIPMENT_RECEIPTED]: {
    caption: 'Принят',
    actions: [OPERATION_MOVE, OPERATION_SALE, OPERATION_DISPOSAL],
  },
  [EQUIPMENT_MOVED]: {
    caption: 'Перемещён',
    actions: [OPERATION_MOVE, OPERATION_SALE, OPERATION_DISPOSAL],
  },
  [EQUIPMENT_SOLD]: {
    caption: 'Продан',
    actions: [],
  },
  [EQUIPMENT_DISPOSED]: {
    caption: 'Ликвидирован',
    actions: [],
  },
}

export const INVENTORY_WORK_FLOW = {
  [INVENTORY_PENDING]: {
    caption: 'Ожидает принятия',
    actions: ['accept', 'reject'],
  },
  [INVENTORY_ACCEPTED]: {
    caption: 'Принят',
    actions: [],
  },
  [INVENTORY_REJECTED]: {
    caption: 'Отказан',
    actions: [],
  },
}

export const DEFAULT_INVENTORY_STATUSES = [INVENTORY_PENDING, INVENTORY_ACCEPTED]

export const DEFAULT_EQUIPMENT_STATUSES = [EQUIPMENT_CREATED, EQUIPMENT_RECEIPTED, EQUIPMENT_MOVED]
